import { render } from "./AIinspection.vue?vue&type=template&id=470f575d&scoped=true"
import script from "./AIinspection.vue?vue&type=script&lang=js"
export * from "./AIinspection.vue?vue&type=script&lang=js"

import "./AIinspection.vue?vue&type=style&index=0&id=470f575d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-470f575d"

export default script